import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-629db18a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-cards" }

import ProfileCard from "@/common/ProfileCard.vue";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";
import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ListCards',
  props: {
  list: {
    type: Array as PropType<ProfileCardInterface[]>,
    default: () => [],
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (card) => {
      return (_openBlock(), _createBlock(ProfileCard, {
        key: card.id,
        card: card
      }, null, 8 /* PROPS */, ["card"]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}
}

})